import React from "react";
import { Link } from "react-router-dom";
import { $t, i18n } from "~/i18n.js";
import { UserAvatar } from "../../profile/UserAvatar.jsx";
import { DropdownMenu } from "~/components/menu/DropdownMenu.jsx";
import { clubHasFinance, clubHasFlight } from "~/featureMatrix.jsx";
import { Tag } from "antd";

export function ProfileMenu({ persist, isAssociationview }) {
  const balance = persist?.balance || 0;

  const menuItems = [
    {
      label: (
        <p>
          {$t("Welkom")} {persist.profile.first_name}
        </p>
      ),
    },
    { type: "divider" },
    !isAssociationview &&
      clubHasFlight() && {
        label: <Link to="/my_starts">{$t("Mijn starts")}</Link>,
      },
    !isAssociationview &&
      !clubHasFlight() && {
        label: <Link to="/my_dto">{$t("Mijn instructieboek")}</Link>,
      },
    !isAssociationview &&
      clubHasFlight() && {
        label: <Link to="/my_maintenance">{$t("Mijn onderhoud")}</Link>,
      },
    {
      label: <Link to="/my_news">{$t("Mijn nieuws")}</Link>,
    },
    {
      label: <Link to="/my_details">{$t("Mijn gegevens")}</Link>,
    },
    !isAssociationview &&
      clubHasFinance() && {
        label: (
          <Link to="/my_account">
            {$t("Mijn betalingen")}
            {balance < 0 && (
              <Tag color="red" style={{ marginLeft: 8 }}>
                {i18n.parseLocaleCurrencyString(balance)}
              </Tag>
            )}
          </Link>
        ),
      },
    { type: "divider" },
    {
      label: <Link to="/logout">{$t("Uitloggen")}</Link>,
    },
  ].filter((f) => f);

  return (
    <DropdownMenu
      trigger={
        <UserAvatar
          className="profileLink"
          user={persist.profile}
          size={35}
          style={{
            height: 35,
            width: 35,
            borderRadius: "50%",
            backgroundColor: "white",
          }}
        />
      }
      items={menuItems}
    />
  );
}
